import BaseAPI from './api';
import env from '../environment';
import { AppConstants } from '../constants/AppConstants';
import { isEmpty } from 'lodash';

const globalHeaders = {
  'Content-Type': 'application/json'
};

const API = BaseAPI?.axiosInstance;

interface ConditionQueryOptions {
  name?: string;
  page?: number;
  size?: number;
  sort?: Array<string>;
  filters?: any;
}

export const getMedicationList = async (
  page: number = AppConstants.DEFAULT_PAGE,
  size: number = AppConstants.DEFAULT_PAGE_SIZE,
  sort: Array<string> = [],
  filters: any = {}
) => {
  const headers = { ...globalHeaders };
  let query = `?${AppConstants.QUERY_PARAM_PAGE}=${page}&${AppConstants.QUERY_PARAM_SIZE}=${size}`;

  if (sort.length) {
    query += '&' + sort.map((e: string) => `sort=${e}`).join('&');
  }
  let uri = `${env.medicationPath}/medications${query}`;
  const response = await API.get(uri, { headers });
  return response;
};
